import Spacing from 'components/Spacing';
import { Stack, VStack } from 'components/Stack';
import Text from 'components/Text';
import { useResponsive } from 'hooks/useResponsive';
import { useTheme } from 'styled-components';

export default function Footer() {
  const theme = useTheme();
  const { isSmallScreen } = useResponsive();
  const fontSize = isSmallScreen ? '1rem' : '1rem';

  return (
    <Stack
      as={'footer'}
      $width='100%'
      $padding='1rem 1rem'
      $paddingBottom='2rem'
      $bgColor={theme.color.primary1000}
    >
      <Text fontFamily='Jua' fontSize={'1.5rem'} color={theme.color.grey100}>
        카공24
      </Text>
      <Spacing margin='0.6rem' />
      <VStack $gap='0.5rem'>
        <Text fontSize={fontSize} color={theme.color.grey100}>
          (주)드랍스튜디오 대표 신승민
        </Text>
        <Text fontSize={fontSize} color={theme.color.grey100}>
          서울특별시 강남구 테헤란로 217 202호
        </Text>
        <Text fontSize={fontSize} color={theme.color.grey100}>
          사업자 등록번호: 165-81-02191
        </Text>
        <Text fontSize={fontSize} color={theme.color.grey100}>
          이메일: dropstudio.company@gmail.com
        </Text>
      </VStack>
    </Stack>
  );
}
